"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterCopyright = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FooterCopyrightWrapper = styled_components_1.default.p(({ theme: { fontSizes, colors, space, media } }) => ({
    fontSize: fontSizes[1],
    color: colors.secondary,
    paddingTop: space[2],
    order: 1,
    [media.tablet]: {
        fontSize: fontSizes[2],
        paddingTop: 0,
        order: -1,
    },
}));
const defaultCopyright = `© 2012–${new Date().getFullYear()}`;
const FooterCopyright = ({ copyright = defaultCopyright, }) => {
    const [t] = (0, next_i18next_1.useTranslation)();
    const FOOTER_COPYRIGHT = `${copyright} ${t('copyright.text')}`;
    return (react_1.default.createElement(FooterCopyrightWrapper, { className: "footer-copyright", dangerouslySetInnerHTML: { __html: FOOTER_COPYRIGHT } }));
};
exports.FooterCopyright = FooterCopyright;
//# sourceMappingURL=FooterCopyright.js.map